import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { DangerousHTMLDiv } from 'ecs-react-components/dist/index.es';
import Header from '../../components/Header/Header';
import { messages } from './Faqs.i18n';
import { loadFaqs } from '../../redux/modules/facility/facility-middleware';

class Faqs extends Component {
  componentDidMount() {
    const {
      dispatch,
      facilityId,
    } = this.props;

    dispatch(loadFaqs(facilityId));
  }

  renderQA(faq, key) {
    return (
      <div className="faq-pair" key={'faq-' + key}>
        <DangerousHTMLDiv
          className="faq-question"
          qaTag={'question-' + key}
          html={faq.question}
        />
        <DangerousHTMLDiv
          className="faq-answer"
          qaTag={'answer-' + key}
          html={faq.answer}
        />
      </div>
    );
  }

  render() {
    const {
      faqs,
    } = this.props;

    return (
    <div className="row" >
      <div className="col-xs-12">
        <Header
          headerClassName="faq-header"
          headerTitle={ <FormattedMessage { ...messages.page.title } /> }
        />
        { faqs && faqs
          .sort((faqA, faqB) => (faqA.viewOrder - faqB.viewOrder))
          .map((faq, key) => this.renderQA(faq, key))}
      </div>
    </div>
    );
  }
}

Faqs.propTypes = ({
  dispatch: PropTypes.func,
  faqs: PropTypes.array,
  facilityId: PropTypes.string,
});

const mapStateToProps = (state) => ({
  faqs: state.facility.resources.faqs,
  facilityId: state.facility.facilityId,
});

export default connect(mapStateToProps)(Faqs);